export default __webpack_public_path__ + "static/media/Cream vase_primary.9db6cddb.jpg";